export const TaskConfigType = {
  Simple: 'simple',
  Text: 'text',
  Enum: 'enum',
  QuestionnaireResponse: 'questionnaireResponse',
  UploadDocument: 'uploadDocument',
} as const
export type TaskConfigType =
  (typeof TaskConfigType)[keyof typeof TaskConfigType]

export const TaskConfigTypeValueToLabel = {
  [TaskConfigType.Simple]: 'Simple task',
  [TaskConfigType.Text]: 'Text input task',
  [TaskConfigType.Enum]: 'Dropdown task',
  [TaskConfigType.QuestionnaireResponse]: 'Questionnaire response task',
  [TaskConfigType.UploadDocument]: 'Document upload task',
} satisfies Record<TaskConfigType, string>

export interface BaseConfig {
  type: TaskConfigType
  required: boolean
  // TODO remove these
  uniqueTaskId?: string
  description?: string
}

export interface SimpleTaskConfig extends BaseConfig {
  type: typeof TaskConfigType.Simple
}
export interface QuestionnaireResponseTaskConfig extends BaseConfig {
  type: typeof TaskConfigType.QuestionnaireResponse
  questionnaireUrl: string
}

export interface UploadDocumentTaskConfig extends BaseConfig {
  type: typeof TaskConfigType.UploadDocument
}

export interface TextTaskConfig extends BaseConfig {
  type: typeof TaskConfigType.Text
}

export interface EnumTaskConfig extends BaseConfig {
  type: typeof TaskConfigType.Enum
  options: string[]
}

export type TaskConfig =
  | SimpleTaskConfig
  | QuestionnaireResponseTaskConfig
  | UploadDocumentTaskConfig
  | TextTaskConfig
  | EnumTaskConfig
